import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { AssetService } from 'src/app/services/asset.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'asset-ironman-inspection-form',
  templateUrl: './ironman-inspection-form.component.html',
  styleUrls: ['./ironman-inspection-form.component.scss']
})
export class IronmanInspectionFormComponent implements OnInit {

  @Input('asset') assetData
  @Input('user') userData
  @Input('documentData') documentDetails
  @Input('singleAsset') assetDetails
  @Input('formType') currentForm
  @Input('userList') assetUserList
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  ironmanInspectionForm: FormGroup
  ironmanInspectionFormData = []
  assetId
  userId
  latitude
  longitude
  isMapEdit
  address: []
  singleAssetDetails
  sign: Boolean = false
  isEdit = false
  files: any = [];
  newFiles: any = [];
  previousIndex: any;
  loading = false
  currentUser: any;
  assetRefList = []
  inspectionFormType
  preparedUserList
  selectedIndex
  selectedFormDetails
  _isControlDisable = false
  _isEnableMap = true
  _isDateDisable = false
  formType

  constructor(
    public _router: Router,
    public _activatedRouter: ActivatedRoute,
    public _cd: ChangeDetectorRef,
    public _assetService: AssetService,
    public _utilityService: UtilityService
  ) { }

  ngOnInit(): void {

    this._activatedRouter.params.subscribe(params => {
      this.assetId = params.id;
      console.log('check params data..', params, this.assetId)
    })
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))


    // this.createForm()
  }


  ngOnChanges(changes: SimpleChanges): void {
    // console.log("Vehicle changes", changes);
    if (changes.currentForm && changes.currentForm.currentValue) {
      this.inspectionFormType = changes.currentForm.currentValue
      if (this.inspectionFormType === 'ironmanInspectionForm') this.formType = 'ironman'
      else this.formType = 'trolley'
      this.createForm()
    }
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetData = changes.assetData.currentValue
      console.log("this.assetData", this.assetData);
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
      console.log("this.userData", this.userData);
    }

    if (changes.documentDetails && changes.documentDetails.currentValue) {
      let data = changes.documentDetails.currentValue
      console.log("DATA OF CURRENT FORM WHILE EDIT", data);
      // this.vehicleInspectionFormData = data
      // console.log("tempData[i].documentMetaId", data[0].userDocumentId.documentMetaId);


      let allFormList = data.filter((x) => x.userDocumentId.documentMetaId.title === this.inspectionFormType)
      console.log("same for data for multiple forms", allFormList);

      if (allFormList && allFormList.length) {
        this.ironmanInspectionFormData = allFormList
        this.selectedIndex = this.ironmanInspectionFormData[0]._id
        this.selectedFormDetails = this.ironmanInspectionFormData[0].userDocumentId
        this._isControlDisable = true
        this._isEnableMap = false
        this._isDateDisable = true
        // this.createForm(this.ironmanInspectionFormData[0].userDocumentId.details[this.inspectionFormType])
        this.changeFormData()
      }
    }
    if (changes.assetDetails && changes.assetDetails.currentValue) {
      this.assetRefList = changes.assetDetails.currentValue
      // this.ironmanInspectionForm.get('assetRef').setValue(this.singleAssetDetails.title)
    }
    if (changes.assetUserList && changes.assetUserList.currentValue) this.preparedUserList = changes.assetUserList.currentValue
    // console.log("THIS IS THE ASSET LIST TO BE DISPLAYU", this.assetRefList)
  }


  // FORM GROUP

  createForm(data?) {
    console.log("CHECK THE DATA FOR FORM", data, this._isControlDisable, typeof this._isControlDisable)
    this.ironmanInspectionForm = new FormGroup({
      equipmentType: new FormControl((data && data.equipmentType) ? data.equipmentType : this.formType),
      assetRef: new FormControl((data && data.assetRef) ? data.assetRef : ''),
      preparedBy: new FormControl((data && data.preparedBy) ? data.preparedBy : ''),
      loadTest: new FormControl((data && data.loadTest) ? data.loadTest : ''),
      testResult: new FormControl((data && data.testResult) ? data.testResult : ''),
      chainOil: new FormControl((data && data.chainOil) ? data.chainOil : ''),
      ledChecked: new FormControl((data && data.ledChecked) ? data.ledChecked : ''),
      breakShoes: new FormControl((data && data.breakShoes) ? data.breakShoes : ''),
      fullComponent: new FormControl((data && data.fullComponent) ? data.fullComponent : ''),
      comment: new FormControl((data && data.comment) ? data.comment : ''),
      wetSign: new FormControl((data && data.wetSign) ? data.wetSign : ''),
      date: new FormControl((data && data.date) ? data.date : null),
      quadrant1: new FormControl((data && data.quadrant1) ? data.quadrant1 : ''),
      quadrant2: new FormControl((data && data.quadrant2) ? data.quadrant2 : ''),
      quadrant3: new FormControl((data && data.quadrant3) ? data.quadrant3 : ''),
      quadrant4: new FormControl((data && data.quadrant4) ? data.quadrant4 : ''),
      quadrant5: new FormControl((data && data.quadrant5) ? data.quadrant5 : ''),
      quadrant6: new FormControl((data && data.quadrant6) ? data.quadrant6 : ''),
      quadrant7: new FormControl((data && data.quadrant7) ? data.quadrant7 : ''),
      quadrant8: new FormControl((data && data.quadrant8) ? data.quadrant8 : ''),
      avgTorque1: new FormControl((data && data.avgTorque1) ? data.avgTorque1 : ''),
      quadrant9: new FormControl((data && data.quadrant9) ? data.quadrant9 : ''),
      quadrant10: new FormControl((data && data.quadrant10) ? data.quadrant10 : ''),
      quadrant11: new FormControl((data && data.quadrant11) ? data.quadrant11 : ''),
      quadrant12: new FormControl((data && data.quadrant12) ? data.quadrant12 : ''),
      quadrant13: new FormControl((data && data.quadrant13) ? data.quadrant13 : ''),
      quadrant14: new FormControl((data && data.quadrant14) ? data.quadrant14 : ''),
      quadrant15: new FormControl((data && data.quadrant15) ? data.quadrant15 : ''),
      quadrant16: new FormControl((data && data.quadrant16) ? data.quadrant16 : ''),
      avgTorque2: new FormControl((data && data.avgTorque2) ? data.avgTorque2 : ''),
    })
    if (this.inspectionFormType === 'handTrolleyForm') {
      this.ironmanInspectionForm.addControl('cableCondition', new FormControl((data && data.cableCondition) ? data.cableCondition : ''))
      this.ironmanInspectionForm.addControl('breakCondition', new FormControl((data && data.breakCondition) ? data.breakCondition : ''))
      this.ironmanInspectionForm.addControl('loadCondition', new FormControl((data && data.loadCondition) ? data.loadCondition : ''))
      this.ironmanInspectionForm.addControl('workingOrder', new FormControl((data && data.workingOrder) ? data.workingOrder : ''))
    }
    console.log("ALL FORMS VALUE", this.ironmanInspectionForm)
    if (this._isControlDisable) {
      this.ironmanInspectionForm.disable()
    }
  }




  // UTILITY



  changeFormTab(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("inspectionFormData", this.ironmanInspectionFormData);
    console.log("index", index);
    this.selectedIndex = this.ironmanInspectionFormData[index]._id
    this.selectedFormDetails = this.ironmanInspectionFormData[index].userDocumentId
    console.log("SELECTED INDEX DATA0", this.selectedIndex)
    if (this.selectedIndex !== 'new') {
      this._isControlDisable = true
      this._isDateDisable = true
      this._isEnableMap = false
    } else {
      this._isControlDisable = false
      this._isDateDisable = false
      this._isEnableMap = true
    }
    // let elemenet = this.ironmanInspectionFormData[index]
    this.changeFormData()
  }


  addNewForm() {
    this._assetService.closeDisplayFile(true)
    let obj = {
      _id: 'new',
      submissionDate: new Date(),
      userDocumentId: {}
    }
    let details = {}
    details[this.inspectionFormType] = {}
    obj.userDocumentId['details'] = details
    this.ironmanInspectionFormData.push(obj)
    this.selectedIndex = this.ironmanInspectionFormData[this.ironmanInspectionFormData.length - 1]._id
    this.selectedFormDetails = this.ironmanInspectionFormData[this.ironmanInspectionFormData.length - 1].userDocumentId
    // this.setCurrentLocation()
    this._isControlDisable = false
    this._isDateDisable = false
    this._isEnableMap = true
    this.createForm()
    // this.isEdit = false
    // this.isMapEdit = false
    this.sign = false
    this.files = []
  }

  compareAssetRef(o1: any, o2: any): boolean {
    // console.log("compareObjects called", o1, o2)
    return o1._id === o2._id;
  }
  comparePreparedUser(o1: any, o2: any): boolean {
    // console.log("compareObjects called", o1, o2)
    return o1.userId === o2.userId;
  }


  changeFormData() {
    console.log("this.selectedFormDetails", this.selectedFormDetails, this._isControlDisable);
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    this.latitude = (this.selectedFormDetails.details[this.inspectionFormType] && this.selectedFormDetails.details[this.inspectionFormType].location) ? this.selectedFormDetails.details[this.inspectionFormType].location.coords.lat : ''
    this.longitude = (this.selectedFormDetails.details[this.inspectionFormType] && this.selectedFormDetails.details[this.inspectionFormType].location) ? this.selectedFormDetails.details[this.inspectionFormType].location.coords.lng : ''
    this.address = (this.selectedFormDetails.details[this.inspectionFormType] && this.selectedFormDetails.details[this.inspectionFormType].location) ? this.selectedFormDetails.details[this.inspectionFormType].location.address : ''
    this.ironmanInspectionForm.value['location'] = {
      coords: { lat: this.latitude, lng: this.longitude },
      address: this.address
    }
    // this.isEdit = true
    this.isMapEdit = true
    if (this.selectedFormDetails.details[this.inspectionFormType].wetSign) this.sign = true
    else this.sign = false
    this.createForm(this.selectedFormDetails.details[this.inspectionFormType])
  }


  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
  }

  onChangeEvent(value) {
    this.ironmanInspectionForm.get('date').setValue(value);
  }

  addSignature() {
    this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
      null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
        if (data == undefined) return
        console.log("data of sign", data);
        this.sign = true
        // this.isSubmit = false
        this.ironmanInspectionForm.patchValue({
          wetSign: data
        })
      })
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;
        fileQueue.filter((x) => {
          if (this.isEdit) {
            this.newFiles.push(x)
          } else {
            this.files.push(x);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }

  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }

  deleteNewFile(event) {
    this.newFiles.splice(event, 1)
  }


  redirect() {
    console.log("CALL THIS FUNCTION OR NOT", this.currentUser)
    this._assetService.closeDisplayFile(true)
    if (this.currentUser && (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('assetManager'))) {
      console.log("user is admin");
      this._router.navigate(['/asset/single-asset/' + this.assetData])
    }
    else {
      this._router.navigate(['/asset/asset-list/'])
    }
  }


  // Calculate Break wheel avg count
  brakedWheelEvent(formControl, start, end) {
    let total = 0
    for (let i = start; i <= end; i++) {
      let formString = 'quadrant' + i
      let formControlValue = this.ironmanInspectionForm.get(formString).value
      total = total + Number(formControlValue)
    }
    this.ironmanInspectionForm.get(formControl).patchValue(Math.floor(total / 8))
  }

  // API CALL

  onSubmit() {
    this.loading = true
    // let formType
    // if (this.inspectionFormType === 'ironmanInspectionForm') formType = 'ironmanInspectionForm'
    let formType = this.inspectionFormType
    if (this.isEdit) {
      console.log("THIS IS EDIT FORM")
    } else {
      let obj = {
        metaObj: {
          title: this.inspectionFormType,
        },
        documentId: this.assetId,
        userId: this.userId,
        onModel: 'asset',
        files: this.files,
        // documentId: this.planFormDetails._id,
        details: {}
      }
      this.ironmanInspectionForm.value['location'] = {
        coords: { lat: this.latitude, lng: this.longitude },
        address: this.address
      }
      let details = {}
      details[this.inspectionFormType] = this.ironmanInspectionForm.value
      // formType: this.ironmanInspectionForm.value
      obj['details'] = details
      console.log("FORM SUBMISSION DATA", obj)
      this._assetService.submitAssetForm(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this._utilityService.handleSnackBar({ msg: `Form Submitted Successfully!`, button: "OK" })
        this.loading = false
        this.redirect();
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
        this.loading = false
      })
    }
  }
}
